module.exports = __webpack_public_path__ + "static/media/pvpsit_logo.6135a562.png";